// IAU 2015 nominal solar diameter (Resolution B3)
export const SUN_DIAMETER_KM = 1_391_400;
export const SUN_RADIUS_KM = SUN_DIAMETER_KM / 2;
